import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TableCell, TableRow } from '@/components/ui/table'

interface Props {
  rows: number
  columns: number
  columnWidth?: number | number[]
}

const SkeletonTableRows: React.FC<Props> = ({ rows, columns, columnWidth }) => {
  function determineColumnWidth(columnIndex: number): number | undefined {
    if (!columnWidth) {
      return undefined
    }

    if (Array.isArray(columnWidth)) {
      return columnWidth[columnIndex]
    }

    return columnWidth
  }

  function makeRows(rowCount: number, columnCount: number) {
    return new Array(rowCount).fill('x').map((_, rowIndex) => (
      <TableRow key={rowIndex}>
        {new Array(columnCount).fill('x').map((_, columnIndex) => {
          return (
            <TableCell
              key={columnIndex}
              style={{ width: determineColumnWidth(columnIndex) }}
            >
              <Skeleton />
            </TableCell>
          )
        })}
      </TableRow>
    ))
  }

  return <>{makeRows(rows, columns)}</>
}

export default SkeletonTableRows
